
import Intersection from './intersection';

export default class Rect {
  constructor () {
    this.element = this.createRect();

    this.sx = 0;
    this.sy = 0;
    this.ex = 0;
    this.ey = 0;
  }

  update (x0, y0, x1, y1) {
    this.sx = Math.min(x0, x1);
    this.sy = Math.min(y0, y1);
    this.ex = Math.max(x0, x1);
    this.ey = Math.max(y0, y1);
    this.element.setAttribute('x', this.sx);
    this.element.setAttribute('y', this.sy);
    this.element.setAttribute('width', this.ex - this.sx);
    this.element.setAttribute('height', this.ey - this.sy);
  }

  intersects (polygon) {
    const points = polygon.polyline.points;
    for (let i = 0, n = points.length; i < n; i++) {
      const p = points[i];
      if (this.sx <= p.x && p.x <= this.ex && this.sy <= p.y && p.y <= this.ey) { return true; }
    }
    return false;
  }

  contains (p) {
    return (this.sx <= p.x && p.x <= this.ex && this.sy <= p.y && p.y <= this.ey);
  }

  area () {
    const dx = this.ex - this.sx;
    const dy = this.ey - this.sy;
    return Math.sqrt(dx * dx) * Math.sqrt(dy * dy);
  }

  createRect () {
    let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    return rect;
  }

  dispose () {
    this.element.remove();
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/rect.js